// React
import PropTypes from "prop-types";

// @mui material components
import { Card, Fade, Grid, Icon, Menu, MenuItem, Modal, Tooltip, Select, Badge } from "@mui/material";

import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import CustomPagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { MessageManager } from "context";
import { ConfirmarContext } from "context/ConfirmarContext";
import { useContext, useEffect, useState } from "react";
import ModalAddOT from "../ModalAddOT";
import dataOrdenesTrabajo from "../data/dataOrdenesTrabajo";
import ModalReservas from "./ModalReservas";
import dayjs from "dayjs";
import Table from "components/Tables/Table";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   maxHeight: "90%",
   width: { xs: "70%", sm: "65%" },
   overflowY: "auto",
};

export default function ModalOrdenesTrabajo({ open, handleClose }) {
   const [rows, setRows] = useState([]);
   const [search, setSearch] = useState("");
   const [fecha, setFecha] = useState(dayjs().format("YYYY-MM-DD"));
   const [searchTimeout, setSearchTimeout] = useState(null);
   const [page, setPage] = useState(1);
   const [filterEstado, setFilterEstado] = useState({ estado: "Todos" });
   const [reservas, setReservas] = useState([]);
   const [selected, setSelected] = useState(null);
   const [openModalStockInsuficiente, setOpenModalStockInsuficiente] = useState(false);
   const [materiasPrimasInsuficientes, setMateriasPrimasInsuficientes] = useState([]);

   const [pagesInfo, setPagesInfo] = useState({
      pages: 0,
      total: 0,
   });
   const [orderBy, setOrderBy] = useState({
      campo: "id",
      orden: "DESC",
   });

   const [getOrdenes, { loading: loadingOrdenes, error, data: dataOrdenes }] = useLazyQuery(
      gql`
       query getOrdenes(
         $pagination: PaginationInput
         $order: Order
         $search: String
         $filter: JSON
       ) {
         paginationInfo {
           pages
           total
         }
         ordenesTrabajo(pagination: $pagination, order: $order, search: $search, filter: $filter) {
           id
           producto {
             id
             nombre
             disponibilidad
             tipoProducto {
               id
               tipo
             }
             combo
             categoriaProducto {
               id
               categoria
             }
           }
           cantPorciones
           fechaEsperadaEntrega
           estado
           observaciones
           createdAt
         }
       }
     `,
      {
         variables: {
            search: search || null,
            pagination: { page: page, limit: 7 },
            order: { field: orderBy.campo, order: orderBy.orden },
            ...(filterEstado?.estado != "Todos" && { filter: filterEstado } || { filter: { estado: ["Pendiente", "EnProceso"] } }),
         },
         fetchPolicy: "network-only",
      }
   );

   const [deleteOrdenTrabajo, { loading: loadingDeleteOT }] = useMutation(
      gql`
         mutation deleteOrdenTrabajo($id: ID!) {
           deleteOrdenTrabajo(id: $id) {
             id
           }
         }
       `
   );

   const [saveOT, { loading: loadingSave }] = useMutation(
      gql`
        mutation saveOrdenTrabajo($input: OrdenTrabajoInput!) {
          saveOrdenTrabajo(input: $input) {
            id
          }
        }
      `,
   );

   const [getReservados, { data: dataResevasPendientes, loading: loadingReservasPendientes }] = useLazyQuery(
      gql`
        query getReservasPendientes($fecha: String) {
          reservadosHoy(fecha: $fecha) {
            idProducto
            productoNombre
            total
            horaReserva
            turnoReserva
            estado
          }
        }
      `,
      {
         fetchPolicy: "no-cache",
      }
   );

   const [modalAddOT, setModalAddOT] = useState(false);
   const [modalReservasPendientes, setModalReservasPendientes] = useState(false);

   const { handleSnackbar } = useContext(MessageManager);
   const { confirmar } = useContext(ConfirmarContext);

   const { columns, getRows } = dataOrdenesTrabajo;

   //Render menu
   const [anchorEl, setAnchorEl] = useState(null);
   const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
   const [selectedOT, setSelectedOT] = useState(null);

   const handleClick = (event, item) => {
      setAnchorEl(event.currentTarget);
      setSelectedOT(item);
   };

   // Cierra todos los menús
   const handleCloseMenu = () => {
      setAnchorEl(null);
      setSubmenuAnchorEl(null);
   };

   const handleSubmenuClick = (event) => {
      if (submenuAnchorEl) {
         setSubmenuAnchorEl(null);
      } else {
         setSubmenuAnchorEl(event.currentTarget);
      }
   };

   const refetchAll = () => {
      getOrdenes()
         .then((res) => {
            setRows(getRows(res.data.ordenesTrabajo, handleClick));
            setPagesInfo(res.data.paginationInfo);
         })
         .catch((err) => console.log(err));

      getReservados({
         variables: {
            fecha: dayjs(fecha).format("YYYY-MM-DD"),
         },
      })
         .then((res) => {
            if (res?.data?.reservadosHoy && Array.isArray(res?.data?.reservadosHoy)) {
               setReservas(res.data.reservadosHoy);
            }
         }).catch((err) => { console.log(err); setReservas([]) });
   }

   const renderMenu = (
      (selectedOT?.estado != "Finalizado" && selectedOT?.estado != "Anulado" && selectedOT?.estado != "Vencido") ? (
         <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
            {
               selectedOT?.estado == "Pendiente" &&
               (
                  <>
                     <MenuItem onClick={() => {
                        setModalAddOT(true);
                        handleCloseMenu();
                     }}>
                        Editar
                        <Icon sx={{ ml: 1 }} color="secondary">
                           edit
                        </Icon>
                     </MenuItem>
                     <MenuItem onClick={() => {
                        if (!loadingDeleteOT) {
                           handleCloseMenu();
                           confirmar({
                              title: "Advertencia",
                              message:
                                 "¿Está seguro que desea borrar esta orden de trabajo?",
                              icon: "warning",
                              func: () => {
                                 deleteOrdenTrabajo({ variables: { id: selectedOT.id } })
                                    .then(() => {
                                       handleSnackbar("Eliminado correctamente", "success");
                                       setSelectedOT(null);
                                       refetchAll();
                                    })
                                    .catch(() => {
                                       handleSnackbar("Ha ocurrido un error al borrar", "error");
                                    });
                              },
                           });
                        }
                     }}>
                        Eliminar
                        <Icon sx={{ ml: 1 }} color="primary">
                           delete
                        </Icon>
                     </MenuItem>
                  </>
               )
            }

            <MenuItem onClick={handleSubmenuClick}>
               Cambiar estado
               <Icon sx={{ ml: 1 }} color="primary">
                  sync
               </Icon>
            </MenuItem>
         </Menu>
      ) : (
         <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
            <MenuItem onClick={() => { }}>
               No hay opciones disponibles
            </MenuItem>
         </Menu>
      )
   );

   const updateStatus = (estado) => {
      saveOT({
         variables: {
            input: {
               id: selectedOT.id,
               estado: estado
            }
         }
      }).then(() => {
         handleSnackbar("Estado actualizado correctamente", "success");
         getOrdenes().then((res) => {
            setRows(getRows(res.data.ordenesTrabajo, handleClick));
            setPagesInfo(res.data.paginationInfo);
         });
      }).catch((err) => {
         const message = err?.message;
         if (
            message &&
            (
               message.startsWith("Stock insuficiente para las siguientes materias primas") ||
               message.startsWith("Stock insuficiente para los siguientes insumos")
            )
         ) {
            const regex = /: (.+)$/;
            const match = message.match(regex);
            let rows = [];
            if (match && match[1]) {
               const items = match[1].split(";").map(i => i.trim()).filter(Boolean);
               rows = items.map(item => {
                  const nombreMatch = item.match(/^(.+?)\s+\(Disponible:/);
                  const disponibleMatch = item.match(/Disponible:\s*([0-9.,]+)\s*([^\s,)]+)/);
                  const requeridoMatch = item.match(/Requerido:\s*([0-9.,]+)\s*([^\s,)]+)/);

                  const swapDotsAndCommas = (str) => {
                     if (!str) return "";
                     return str.replace(/[.,]/g, (c) => (c === "." ? "," : "."));
                  };

                  return {
                     nombre: (
                        <SoftTypography
                           verticalAlign="text-top"
                           variant="button"
                           color="dark"
                           fontWeight="bold"
                           title={nombreMatch && nombreMatch[1] ? nombreMatch[1] : ""}
                        >
                           {nombreMatch && nombreMatch[1] ? nombreMatch[1] : ""}
                        </SoftTypography>
                     ),
                     disponible: (
                        <SoftTypography
                           variant="button"
                           color="secondary"
                           fontWeight="regular"
                        >
                           {disponibleMatch && disponibleMatch[1] ? swapDotsAndCommas(disponibleMatch[1]) : ""}
                           {disponibleMatch && disponibleMatch[2] ? ` ${disponibleMatch[2]}` : ""}
                        </SoftTypography>
                     ),
                     requerido: (
                        <SoftTypography
                           variant="button"
                           color="secondary"
                           fontWeight="regular"
                        >
                           {requeridoMatch && requeridoMatch[1] ? swapDotsAndCommas(requeridoMatch[1]) : ""}
                           {requeridoMatch && requeridoMatch[2] ? ` ${requeridoMatch[2]}` : ""}
                        </SoftTypography>
                     ),
                  };
               });
            }
            setMateriasPrimasInsuficientes(rows);
            setOpenModalStockInsuficiente(true);
         } else if (message) {
            handleSnackbar(message, "warning");
         } else {
            handleSnackbar("Ha ocurrido un error al actualizar un estado", "error");
         }
      }).finally(() => {
         setSelectedOT(null);
         handleCloseMenu();
      })
   }

   const editEstado = (estado) => {
      if (estado == "EnProceso") {
         confirmar({
            title: "Atención",
            message:
               "Este cambio de estado implica una reducción del stock de ingredientes necesarios para la elaboración de las porciones de la orden de trabajo creada ¿Desea continuar?",
            icon: "warning",
            func: () => {
               updateStatus(estado);
            },
         });
      } else {
         updateStatus(estado);
      }
   }

   const renderSubMenu = (
      <Menu
         anchorEl={submenuAnchorEl}
         open={Boolean(submenuAnchorEl)}
         onClose={() => setSubmenuAnchorEl(null)}
         anchorOrigin={{ vertical: "top", horizontal: "right" }}
         transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
         {selectedOT?.estado == "Pendiente" &&
            <MenuItem onClick={() => editEstado("EnProceso")}>
               En Proceso
               <Icon sx={{ ml: 1 }} color="dark">
                  task_alt
               </Icon>
            </MenuItem>
         }
         {selectedOT?.estado == "EnProceso" &&
            <MenuItem onClick={() => editEstado("Finalizado")}>
               Finalizado
               <Icon sx={{ ml: 1 }} color="success">
                  stop_circle
               </Icon>
            </MenuItem>
         }
         {selectedOT?.estado != "Anulado" && selectedOT?.estado != "Finalizado" &&
            <MenuItem onClick={() => editEstado("Anulado")}>
               Anulado
               <Icon sx={{ ml: 1 }} color="error">
                  cancel
               </Icon>
            </MenuItem>
         }
      </Menu>
   );


   const handleOrderBy = (campo) => {
      if (orderBy.campo === campo) {
         if (orderBy.orden === "ASC") {
            setOrderBy({
               campo: campo,
               orden: "DESC",
            });
         } else {
            setOrderBy({
               campo: campo,
               orden: "ASC",
            });
         }
      } else {
         setOrderBy({
            campo: campo,
            orden: "ASC",
         });
      }
   };
   const handleSearch = (event) => {
      const newTimeout = setTimeout(() => {
         setSearch(event.target.value);
         setPage(1);
      }, 500);
      if (searchTimeout) {
         clearTimeout(searchTimeout);
      }
      setSearchTimeout(newTimeout);
   };

   useEffect(() => {
      if (open) {
         refetchAll();
      }
   }, [search, page, orderBy, filterEstado, open]);

   useEffect(() => {
      if (fecha) {
         getReservados({
            variables: {
               fecha: dayjs(fecha).format("YYYY-MM-DD"),
            },
         })
            .then((res) => {
               if (res?.data?.reservadosHoy && Array.isArray(res?.data?.reservadosHoy)) {
                  setReservas(res.data.reservadosHoy);
               }
            }).catch((err) => { console.log(err); setReservas([]) });
      }
   }, [fecha]);



   return (
      <Modal
         aria-labelledby="transition-modal-title"
         aria-describedby="transition-modal-description"
         open={open}
         onClose={handleClose}
         closeAfterTransition
      >
         <Fade in={open}>
            <Card sx={style}>
               <SoftBox>
                  <Card>
                     <Grid container spacing={2} p={3}>
                        <Grid item xs={12}>
                           <SoftBox
                              display={{
                                 xs: "flex-row",
                                 sm: "flex",
                              }}
                              justifyContent="space-between"
                              alignItems="center"
                           >
                              <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                                 <SoftTypography variant="h6">Ordenes de trabajo</SoftTypography>
                                 <SoftBox
                                    display={{
                                       xs: "block",
                                       sm: "none",
                                    }}
                                 >
                                    {/* <Tooltip
                                       title={dataResevasPendientes?.reservadosHoy?.length > 0 ? "Hay reservas pendientes" : ""}
                                       placement="top"
                                    >
                                       <SoftButton sx={{ mr: 2 }} color="uproYellow" circular iconOnly onClick={() => setModalReservasPendientes(true)}>
                                          {dataResevasPendientes?.reservadosHoy?.length > 0 ? <Badge badgeContent={<Icon fontSize="small" >priority_high</Icon>} color="error">
                                             <Icon sx={{ mx: 1 }}>restaurant</Icon>
                                          </Badge> : <Icon sx={{ mx: 1 }}>restaurant</Icon>}
                                       </SoftButton>
                                    </Tooltip> */}
                                    <Tooltip title="Agregar una nueva orden de trabajo" placement="top">
                                       <SoftButton
                                          color="primary"
                                          circular
                                          iconOnly
                                          onClick={() => { setSelectedOT(null); setModalAddOT(true) }}
                                       >
                                          <Icon>add</Icon>
                                       </SoftButton>
                                    </Tooltip>
                                 </SoftBox>
                              </SoftBox>

                              <SoftBox
                                 display="flex"
                                 alignItems="center"
                                 justifyContent="end"
                                 mt={{
                                    xs: 2,
                                    sm: 0,
                                 }}
                              >
                                 <SoftBox mr={2}>
                                    <Select name="provincia" value={filterEstado?.estado} onChange={(e) => { setPage(1); setFilterEstado({ estado: e.target.value }) }}>
                                       <MenuItem value={-1} disabled>
                                          Filtro por Estado
                                       </MenuItem>
                                       <MenuItem value="Pendiente">
                                          Pendiente
                                       </MenuItem>
                                       <MenuItem value="EnProceso">
                                          En proceso
                                       </MenuItem>
                                       <MenuItem value="Finalizado">
                                          Finalizado
                                       </MenuItem>
                                       <MenuItem value="Anulado">
                                          Anulado
                                       </MenuItem>
                                       <MenuItem value="Vencido">
                                          Vencido
                                       </MenuItem>
                                       <MenuItem value="Todos">
                                          Pendientes / En Proceso
                                       </MenuItem>
                                    </Select>
                                 </SoftBox>
                                 <SoftBox
                                    mr={{
                                       xs: 0,
                                       sm: 2,
                                    }}
                                    sx={{
                                       width: {
                                          xs: "100%",
                                          sm: "auto",
                                       },
                                    }}
                                 >
                                    <SoftInput
                                       placeholder="Escribe aquí..."
                                       icon={{ component: "search", direction: "left" }}
                                       onChange={handleSearch}
                                    />
                                 </SoftBox>
                                 <SoftBox
                                    display={{
                                       xs: "none",
                                       sm: "block",
                                    }}
                                 >
                                    {/* <Tooltip
                                       title={dataResevasPendientes?.reservadosHoy?.length > 0 ? "Hay reservas pendientes" : ""}
                                       placement="top"
                                    >
                                       <SoftButton sx={{ mr: 2 }} color="uproYellow" circular iconOnly onClick={() => setModalReservasPendientes(true)}>
                                          {dataResevasPendientes?.reservadosHoy?.length > 0 ? <Badge badgeContent={<Icon fontSize="small" >priority_high</Icon>} color="error">
                                             <Icon sx={{ mx: 1 }}>restaurant</Icon>
                                          </Badge> : <Icon sx={{ mx: 1 }}>restaurant</Icon>}
                                       </SoftButton>
                                    </Tooltip> */}
                                    <Tooltip title="Agregar una nueva orden de trabajo" placement="top">
                                       <SoftButton
                                          color="primary"
                                          circular
                                          onClick={() => { setSelectedOT(null); setModalAddOT(true) }}
                                       >
                                          <Icon>add</Icon>
                                          &nbsp;Agregar
                                       </SoftButton>
                                    </Tooltip>
                                 </SoftBox>
                              </SoftBox>
                           </SoftBox>
                        </Grid>
                     </Grid>
                     <SoftBox
                        sx={{
                           "& .MuiTableRow-root:not(:last-child)": {
                              "& td": {
                                 borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                    `${borderWidth[1]} solid ${borderColor}`,
                              },
                           },
                           width: "100%",
                        }}
                     >
                        {loadingOrdenes ? (
                           <Loading />
                        ) : rows?.length > 0 ? (
                           <>
                              <DataTable
                                 columns={columns}
                                 rows={rows}
                                 order={orderBy}
                                 setOrder={handleOrderBy}
                              />
                              {renderMenu}
                              {renderSubMenu}
                           </>
                        ) : (
                           <SinDatos />
                        )}
                     </SoftBox>
                     <CustomPagination
                        loading={loadingOrdenes}
                        length={rows?.length}
                        total={pagesInfo?.total}
                        pages={pagesInfo?.pages}
                        page={page}
                        setPage={setPage}
                        noCard
                     />
                  </Card>
                  <ModalAddOT
                     open={modalAddOT}
                     handleClose={() => {
                        setModalAddOT(false);
                        setSelectedOT(null);
                        setSelected(null);
                     }}
                     refetch={refetchAll}
                     selectedOT={selectedOT}
                     selected={selected}
                  />
                  <ModalReservas
                     open={modalReservasPendientes}
                     handleClose={() => {
                        setModalReservasPendientes(false);
                     }}
                     refetch={refetchAll}
                     reservas={reservas || []}
                     loadingReservasPendientes={loadingReservasPendientes}
                     selected={selected}
                     setSelected={setSelected}
                     setModalAddOT={setModalAddOT}
                     fecha={fecha}
                     setFecha={setFecha}
                  />
                  <Modal
                     aria-labelledby="modal-stock-insuficiente-title"
                     aria-describedby="modal-stock-insuficiente-description"
                     open={openModalStockInsuficiente}
                     onClose={() => setOpenModalStockInsuficiente(false)}
                     sx={{ width: "100%" }}
                     closeAfterTransition
                  >
                     <Fade in={openModalStockInsuficiente}>
                        <Card sx={{
                           position: "absolute",
                           top: "50%",
                           left: "50%",
                           transform: "translate(-50%, -50%)",
                           width: '45%',
                           p: 3,
                        }}>
                           <SoftBox display="flex" gap={1} alignItems="center" mb={2}>
                              <Icon fontSize="medium" color="warning">warning</Icon>
                              <SoftTypography variant="h6">
                                 Stock insuficiente
                              </SoftTypography>
                           </SoftBox>
                           <SoftBox mb={2}>
                              <Table
                                 columns={[
                                    { name: "nombre", desc: "Insumo", align: "center", width: "50%" },
                                    { name: "disponible", desc: "Disponible", align: "center", width: "25%" },
                                    { name: "requerido", desc: "Requerido", align: "center", width: "25%" }
                                 ]}
                                 rows={materiasPrimasInsuficientes}
                              />
                           </SoftBox>
                           <SoftBox display="flex" flexDirection="column" gap={2} mt={2}>
                              <SoftButton
                                 variant="gradient"
                                 color="secondary"
                                 onClick={() => setOpenModalStockInsuficiente(false)}
                                 circular
                                 fullWidth
                              >
                                 <Icon>undo</Icon>&nbsp;Volver
                              </SoftButton>
                           </SoftBox>
                        </Card>
                     </Fade>
                  </Modal>
               </SoftBox>
            </Card>
         </Fade>
      </Modal>
   );
}

ModalOrdenesTrabajo.propTypes = {
   open: PropTypes.bool,
   handleClose: PropTypes.func,
   refetch: PropTypes.func,
};
